import { sharedEnvironment } from '@raptor-fe/core';
import { MarlinEnvironment } from './marlin-environment';

export const environment: MarlinEnvironment = {
    ...sharedEnvironment,
    baseUrl: 'https://api.raptor.development.megabus.com.au/api/',
    baseReportUrl: 'https://reports.raptor.development.megabus.com.au/api/',
    federationApiUrl: 'https://federation.raptor.development.megabus.com.au/api/',
    auditApiBaseUrl: 'https://audit.raptor.development.megabus.com.au/api/',
    staffSignInEnabled: true,
    entra: {
        tenantId: '748b5735-b385-41d2-a99d-806bb5c45789',
        clientId: '75f3a011-df91-40a5-af04-a865a6bdcb62',
        redirectUri: '',
    },
};
